// extracted by mini-css-extract-plugin
export var externalLink = "_bs-0";
export var internalLinkLabel = "_bs-1";